import type { ProviderFieldError } from '@/domain/providerConfig';
import { penKey } from '@/routes/shared/ProviderConfig/form/formKeys';

const REQUIRED_CODES = new Set(['required', 'newPenSecretRequired']);

/**
 * Whether a value the test needs is still empty for the pens it would test: a required site
 * setting or credential, or one of those pens' own. The server would only answer that the
 * settings are incomplete, so the test waits until the marked fields are filled.
 */
export function missesRequiredForTest(
    errors: readonly ProviderFieldError[],
    cageIds: readonly number[]
): boolean {
    const penPrefixes = cageIds.map((cageId) => `pens.${penKey(cageId)}.`);
    return errors.some(
        ({ path, code }) =>
            REQUIRED_CODES.has(code) &&
            (path.startsWith('connection.') ||
                path.startsWith('secrets.') ||
                penPrefixes.some((prefix) => path.startsWith(prefix)))
    );
}
